export const MATERIAL_MAX = {
  code: 50,
  name: 50,
  description: 2000,
  hierarchicalCode: 500,
};

export const MATERIAL_CATEGORY_MAX = {
  code: 50,
  name: 50,
  description: 2000,
  hierarchicalCode: 500,
};
